import { defineMessages } from 'react-intl';
export const messages = defineMessages({
  logout: {
    id: 'jutro-router.DropdownMenu.Logout',
    defaultMessage: 'Logout'
  }
});